module.exports = __webpack_public_path__ + "img/g1-5-e.df357dfd.png";